import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";
import "./i18n/config";
// import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

axios.defaults.headers.common["X-Frontend-Key"] =
  "dxgVwFpJQ076CP0kjJIKYF4xyvjm9CQIJ-rZlY8YAYA";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
